import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "../store";

const dashboardState = (state: RootState) => state.dashBaord;

const selectDashboardStats = createSelector(
  dashboardState,
  (state) => state.dashboard,
);

const selectSetup = createSelector(dashboardState, (state) => state.setup);

const selectToday = createSelector(dashboardState, (state) => state.today);

const selectTodayLoading = createSelector(
  dashboardState,
  (state) => state.todayLoading,
);

const selectTodayFailed = createSelector(
  dashboardState,
  (state) => state.todayFailed,
);

const selectDataVersion = createSelector(
  dashboardState,
  (state) => state.dataVersion,
);

export const dashboardSliceSelectors = {
  selectDashboardStats,
  selectSetup,
  selectToday,
  selectTodayLoading,
  selectTodayFailed,
  selectDataVersion,
};
